import React from "react";

import { cn } from "@/lib/utils";

import { CommandInput as CommandInputPrimitive } from "cmdk";

import type { Icon } from "@/components/ui/Icons";

const CommandInput = React.forwardRef<
  React.ElementRef<typeof CommandInputPrimitive>,
  React.ComponentPropsWithoutRef<typeof CommandInputPrimitive> & {
    disabled?: boolean;
    leftIcon?: Icon;
    leftIconClassName?: string;
  }
>(
  (
    {
      children,
      className,
      disabled = false,
      leftIcon = null,
      leftIconClassName = null,
      ...props
    },
    ref,
  ) => {
    const LeftIconComp = leftIcon;
    const CommandInputComponent = (
      <CommandInputPrimitive
        ref={ref}
        className={cn(
          "flex h-6 rounded-lg bg-white px-0 text-body-sm ring-offset-white placeholder:text-tertiary focus:outline-none disabled:bg-tertiary disabled:cursor-not-allowed disabled:opacity-50",
          children ? "w-auto" : "w-full",
          className,
        )}
        disabled={disabled}
        {...props}
      />
    );

    return (
      <div
        className={cn(
          "flex items-center px-2 py-1 box-border border rounded-lg border-secondary focus-within:border-link",
          disabled && "cursor-not-allowed bg-tertiary",
          !disabled && "bg-white",
        )}
      >
        {LeftIconComp && (
          <LeftIconComp
            className={cn(
              "mr-2 h-4 w-4 shrink-0 opacity-50",
              leftIconClassName,
            )}
          />
        )}
        {children ? (
          <div className="flex flex-wrap flex-1 items-center">
            {children}
            {CommandInputComponent}
          </div>
        ) : (
          CommandInputComponent
        )}
      </div>
    );
  },
);

CommandInput.displayName = CommandInputPrimitive.displayName;
export { CommandInput };
